export default {
  login: "/auth/login",
  verify: "/auth",
  comments: "/comments",
  refreshtoken: "/api/refreshtoken",
  signup: "/auth/register",
  conditions: "/conditions",
  resources: "/customers/attributes",
  eventResources: "/events/attributes",
  eventAttributes: "/events/possible-attributes",
  customersAttributes: "/customers/possible-attributes",
  campaigns: "/campaigns",
  segments: "/segments",
  domains: "/email/domains",
  resendDomains: "/email/resend/domains",
  updateUserInfo: "/accounts",
  audiences: "/audiences",
  addtemplate: "/audiences/add-template",
  createSegment: "/audiences/create",
  updateSegment: "/audiences/update",
  createTemplate: "/templates/create",
  correlateSlack: "/slack/cor",
  getAllTemplates: "/templates",
  getAllPeople: "/customers",
  searchCustomersForTest: "/customers/search-for-test",
  customerCreate: "/customers/create",
  customerDelete: "/customers/delete/",
  flow: "/workflows",
  journeys: "/journeys",
  startFlow: "/workflows/start",
  deleteFlow: "/workflows/delete",
  slackInstall: "/slack/install",
  syncPosthog: "/customers/importph",
  deleteMedia: "accounts/delete-media/",
};
